import { createSlice } from "@reduxjs/toolkit";
import { colourToColourObjectType } from "../../utils/ColourGenerators/ColourToColourObjectType";

export interface manualColour {
  name: string | null;
  value: {
    rgb: {
      r: number;
      g: number;
      b: number;
    };
    hex: string;
    hsl: {
      h: number;
      s: number;
      l: number;
    };
  };
  category: any;
  associateColours: any;
}
interface initalColourState {
  colour: null | manualColour;
  isChangeable: boolean;
}
const initialColourState: initalColourState = {
  colour: colourToColourObjectType("#0A2C37", "Colour 1"),
  isChangeable: true,
};

export const selectedColoursSlice = createSlice({
  name: "selectedColours",
  initialState: initialColourState,
  reducers: {
    setAsSelectedColour: (state, action) => {
      state.colour = action.payload.colour;
      state.isChangeable = action.payload.isChangeable;
    },
    removeAsSelectedColour: (state) => {
      //@ts-ignore
      state.colour = null;
      state.isChangeable = false;
    },
    editSelectedColour: (state, action) => {
      state.colour = action.payload;
    },
    resetSelectedColour: (state) => {
      state.colour = colourToColourObjectType("#0A2C37", "Colour 1");
      state.isChangeable = true;
    }
  },
});

// Action creators are generated for each case reducer function
export const { setAsSelectedColour, removeAsSelectedColour, editSelectedColour, resetSelectedColour } =
  selectedColoursSlice.actions;

export default selectedColoursSlice.reducer;
